import { useEffect } from 'react';
import Header from 'next/head';
import AffiliateOrder from '@/pages/AffiliateOrder';
import AnalyticsEventHandler from '@/services/analytics/AnalyticsEventHandler';

const WebPage = () => {
  useEffect(() => {
    AnalyticsEventHandler.trackWebPageView();
  }, []);

  return (
    <>
      <Header>
        <title>Buy ClearVPN. Expand and secure online activities with VPN hassle-free.</title>
        <meta
          name="description"
          content="Buy ClearVPN risk-free. Enjoy the full online potential with just a tap. Buy VPN and forget about server-picking."
        />
      </Header>

      <AffiliateOrder customAppIdentity="clearvpn2.affiliate.trials" />
    </>
  );
};

export default WebPage;
